export default "__VITE_ASSET__d09103c9__"